import SingleNews from "./singleNews";
export default SingleNews;
